import { Button, Icon, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { MessageContainer } from "../container"
import { icons } from "../../../../../../../utils/icons"

const MessageUsersExisted = (props: {
  return: () => void
}) => {
  const { t } = useTranslation()
  const styles = useStyles()

  return (
    <MessageContainer >
      <>
        <Icon sx={styles.warning}>{icons('info')}</Icon>

        <Typography sx={styles.text}>{t("general.messages.errors.allUsersExisted")}</Typography>

        <Button onClick={() => { props.return() }} variant="contained">{t('general.confirm')}</Button>
      </>
    </MessageContainer>
  )
}

export { MessageUsersExisted }
